module.exports = __webpack_public_path__ + "img/03-avatar male.8444a94f.png";